// JavaScript Document
//components/signs/category/Table.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import SendIcon from '@material-ui/icons/Telegram';
import StopIcon from '@material-ui/icons/Cancel';
import moment from 'moment';
import useWebSocket, { ReadyState } from 'react-use-websocket';
//import 'moment-precise-range-plugin';



const useStyles = makeStyles((theme) => {
  return {
  table: {
	  maxHeight:254,
	  flexGrow: 1,
	//maxHeight: '100%'
  },
	datecol : {
		minWidth: 100
	},
  textbox : {
    padding: theme.spacing(1),
    margin: 'auto'
  }
}

});


export default function UpdateDetails(props) {
	const classes = useStyles();
	const {items, sign, updateSign, handleSave} = props;
  const [updateItems, setUpdateItems] = React.useState(items);
  const [queLabel, setQueLabel] = React.useState('Update Now');
  const [killLabel, setKillLabel] = React.useState('Stop update');
  //console.log('process.env', process.env);
  const handleIncoming = (data) => {
    data.date = moment().format('YYYY-MM-DD');
    data.time = moment().format('HH:mm:ss');
    if(data.log_type === 'start'){
      //set status to updating
      updateSign({
        last_update_status: 2
      }, true)
      return setUpdateItems([data]);
    }
    
    let uitems = Object.assign([], updateItems);
    uitems.unshift(data);
    setUpdateItems(uitems);
    if(data.log_type === 'finish'){
      updateSign({
        //next update tomorrow
        next_update : moment(Date.now() + 1000 * 60 * 60 * 24).format('YYYY-MM-DD HH:mm:ss'),
        last_update_status : 1
      }, true);
      setQueLabel('Update Now');
    }
  }

  //attempt to open web socket
  const { sendJsonMessage, readyState} = useWebSocket(process.env.REACT_APP_WEBSOCKET_URL, {
      onOpen : () => {
          console.log('WebSocket connection established.');
          sendJsonMessage({
            action : 'listen',
            id : sign.id
          });
      },
      shouldReconnect: (closeEvent) => true,
      onMessage: (e) => {
        //console.log('message', e);
        handleIncoming(JSON.parse(e.data));
      },
      share: true,
    });


  const getFinish = () => {
    return updateItems.find(n => n.log_type === 'finish');
  }
  const getDuration = (seconds) => {
    if(seconds < 60) return [seconds, 'seconds'].join(' ');
    return moment.duration(seconds * 1000).humanize();
  }
  const getHeader = () => {
    let finish = getFinish() || updateItems[0];
    
    return [
      (<Typography key={1} variant="h5">Last Update</Typography>),
      (<Typography key={2}>{moment([finish.date, finish.time].join(' ')).fromNow()} took {getDuration(finish.duration)}</Typography>)
      //moment.preciseDiff(0, finish.duration * 1000)
      
    ];
  }
  const summarize = (type) => {
    let files = updateItems.filter(n => n.log_type === type).map(f => Object.assign(f, JSON.parse(f.description)));
    if(files.length === 0) return null;
    return {
      name : (type === 'SPL' ? 'Speed Data' : 'Analog Data'),
      total : files.length,
      duration : files.reduce((a, v) => a + v.duration, 0),
      size : files.reduce((a, v) => a + v.size, 0),
      files : files
    }
  }
  const getFiles = () => {
    return ['SPL', 'ANL'].map(s => summarize(s)).filter(n => n);
  }
  const round = (number, precision) => {
    let prec = precision || 1;
    let comp = Math.pow(10, prec);
    return Math.round(number * comp) / comp;
  }
  const getSize = (bytes) => {
    if(bytes < 1024) return [bytes, 'bytes'].join(' ');
    if(bytes < 1024 * 1024) return [round(bytes / 1024), 'kb'].join('');
    if(bytes < 1024 * 1024 * 1024) return [round(bytes / 1024 / 1024), 'mb'].join('');
    return [round(bytes / 1024 / 1024 / 1024), 'gb'].join('');
  }

  const isSockReady = () => {
    return readyState === ReadyState.OPEN 
      && sign.sign_type_obj 
      && sign.sign_type_obj.class_code === 'Ph4';
  }
  const updateNow = () => {
    setQueLabel('Starting');
    //Socket is open and a ph4 sign
    if(isSockReady()){
       //send message to websocket to start
      sendJsonMessage({
        action : 'start',
        id : sign.id
      });
      //set status in UI to updating
      return updateSign({
          last_update_status : 2
      }, true);
    }
   
    //socket not open, use the php webserver
    //set the update time to past
    updateSign({
      next_update : moment().format('YYYY-MM-DD HH:mm:ss')
    }, true);
    handleSave();
  }

  const killNow = () => {
    setKillLabel('Terminating');
    if(isSockReady()){
      //send message to websocket to kill update
      sendJsonMessage({
        action : 'stop',
        id : sign.id
      });
      return updateSign({
        kill_update : 1
      }, true);
    }
    //socket is not open, must do it via php server
    updateSign({
      kill_update : 1
    }, true);
    handleSave();
}

  const renderUpdateNow = () => {
    return (
    <Button
						variant="contained"
						color="primary"
						onClick={updateNow}
						endIcon={<SendIcon />}
            disabled={queLabel === 'Starting' ? true : false}
					>{queLabel}</Button>
    );
  }
  const nextUpdate = () => {
    if(sign.load_pri || sign.auto_update){
      if(parseInt(sign.last_update_status) === 2){
        if(sign.kill_update){
          return (<Typography>Terminating update in progress</Typography>)
        }
        return (
          <div>
            <Typography>Update in progress</Typography>
            <Button
						  variant="contained"
						  color="secondary"
						  onClick={killNow}
						  endIcon={<StopIcon />}
              disabled={killLabel === 'Terminating' ? true : false}
					  >{killLabel}</Button>
          </div>
        );
      }
      if(moment(sign.next_update).format('x') < Date.now()){
        return (
        <div>
            <Typography>Queued for update</Typography>
            {isSockReady() ? renderUpdateNow() : ''}
        </div>
        );
      }
      return (
        <div>
          <Typography>Next update: {moment(sign.next_update).fromNow()}</Typography>
          {renderUpdateNow()}
        </div>
      );
    }
    return '';
  }

  const renderResult = (row) => {
    if(['SPL', 'ANL', 'PRI', 'DIRECTORY'].indexOf(row.log_type.toUpperCase()) === -1) return row.description;
    let file = JSON.parse(row.description);
    if(row.log_type.toUpperCase() === 'DIRECTORY') return file.length+' files';
    return getSize(file.size);
  }
  return (
    <Paper>
      <div className={classes.textbox}>
      {getHeader()}
      {getFiles().map((f, i) => (
        <Typography id={i}>{getSize(f.size)} of {f.name} downloaded in {getDuration(f.duration)}</Typography>
      ))}
      {nextUpdate()}
      </div>
    <TableContainer component={Paper} className={classes.table}>
      <Table stickyHeader aria-label="sign categories">
        <TableHead>
          <TableRow>
	  		    <TableCell>Date</TableCell>
            <TableCell>Action</TableCell>
            <TableCell>Result</TableCell>
            <TableCell>Seconds</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {updateItems.map((row) => (
            <TableRow hover role="checkbox" key={row.id}>
              <TableCell component="th" scope="row" className={classes.datecol}>
                {moment(row.date+" "+row.time).fromNow()}
              </TableCell>
	  			    <TableCell>{row.log_type}</TableCell>
              <TableCell>{renderResult(row)}</TableCell>
              <TableCell>{row.duration}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Paper>
  );
}
